import * as i0 from '@angular/core';
import * as i1 from './tree-grid.module';
import * as i2 from '@angular/common';
import * as i3 from '../cdk/table/table.module';
import * as i4 from '../cdk/table/cell';
import * as i5 from '../cdk/table/row';
import * as i6 from '../icon/icon.component';
import * as i7 from './tree-grid.component';
import * as i8 from './tree-grid-def.component';
import * as i9 from './tree-grid-row.component';
import * as i10 from './tree-grid-cell.component';
import * as i11 from './tree-grid-column-def.directive';
import * as i12 from './tree-grid-sort.component';
import * as i13 from './tree-grid-filter';
import * as i14 from './tree-grid-row-toggle.directive';
import * as i15 from './tree-grid-row-toggle.component';
import * as i16 from '../icon/icon.module';
export const ElTreeGridModuleNgFactory:i0.NgModuleFactory<i1.ElTreeGridModule> = (null as any);
var _decl0_0:i2.NgClass = (<any>(null as any));
var _decl0_1:i2.NgComponentOutlet = (<any>(null as any));
var _decl0_2:i2.NgForOf<any> = (<any>(null as any));
var _decl0_3:i2.NgIf = (<any>(null as any));
var _decl0_4:i2.NgTemplateOutlet = (<any>(null as any));
var _decl0_5:i2.NgStyle = (<any>(null as any));
var _decl0_6:i2.NgSwitch = (<any>(null as any));
var _decl0_7:i2.NgSwitchCase = (<any>(null as any));
var _decl0_8:i2.NgSwitchDefault = (<any>(null as any));
var _decl0_9:i2.NgPlural = (<any>(null as any));
var _decl0_10:i2.NgPluralCase = (<any>(null as any));
var _decl0_11:i3.ElTable<any> = (<any>(null as any));
var _decl0_12:i4.ElHeaderCellDefDirective = (<any>(null as any));
var _decl0_13:i5.ElHeaderRowDefDirective = (<any>(null as any));
var _decl0_14:i4.ElColumnDefDirective = (<any>(null as any));
var _decl0_15:i4.ElCellDefDirective = (<any>(null as any));
var _decl0_16:i5.ElRowDefDirective<any> = (<any>(null as any));
var _decl0_17:i4.ElFooterCellDefDirective = (<any>(null as any));
var _decl0_18:i5.ElFooterRowDefDirective = (<any>(null as any));
var _decl0_19:i5.ElDataRowOutletDirective = (<any>(null as any));
var _decl0_20:i5.ElHeaderRowOutletDirective = (<any>(null as any));
var _decl0_21:i5.ElFooterRowOutletDirective = (<any>(null as any));
var _decl0_22:i5.ElCellOutletDirective = (<any>(null as any));
var _decl0_23:i4.ElHeaderCellDirective = (<any>(null as any));
var _decl0_24:i4.ElCellDirective = (<any>(null as any));
var _decl0_25:i4.ElFooterCellDirective = (<any>(null as any));
var _decl0_26:i5.ElHeaderRowComponent = (<any>(null as any));
var _decl0_27:i5.ElRowComponent = (<any>(null as any));
var _decl0_28:i5.ElFooterRowComponent = (<any>(null as any));
var _decl0_29:i6.ElIconComponent = (<any>(null as any));
var _decl0_30:i7.ElTreeGridComponent<any> = (<any>(null as any));
var _decl0_31:i8.ElTreeGridRowDefDirective<any> = (<any>(null as any));
var _decl0_32:i9.ElTreeGridRowComponent = (<any>(null as any));
var _decl0_33:i8.ElTreeGridCellDefDirective = (<any>(null as any));
var _decl0_34:i10.ElTreeGridCellDirective = (<any>(null as any));
var _decl0_35:i8.ElTreeGridHeaderRowDefDirective = (<any>(null as any));
var _decl0_36:i9.ElTreeGridHeaderRowComponent = (<any>(null as any));
var _decl0_37:i8.ElTreeGridHeaderCellDefDirective = (<any>(null as any));
var _decl0_38:i10.ElTreeGridHeaderCellDirective = (<any>(null as any));
var _decl0_39:i8.ElTreeGridFooterRowDefDirective = (<any>(null as any));
var _decl0_40:i9.ElTreeGridFooterRowComponent = (<any>(null as any));
var _decl0_41:i8.ElTreeGridFooterCellDefDirective = (<any>(null as any));
var _decl0_42:i10.ElTreeGridFooterCellDirective = (<any>(null as any));
var _decl0_43:i11.ElTreeGridColumnDefDirective = (<any>(null as any));
var _decl0_44:i12.ElSortDirective = (<any>(null as any));
var _decl0_45:i12.ElSortHeaderComponent = (<any>(null as any));
var _decl0_46:i12.ElSortIconComponent = (<any>(null as any));
var _decl0_47:i13.ElFilterDirective = (<any>(null as any));
var _decl0_48:i13.ElFilterInputDirective = (<any>(null as any));
var _decl0_49:i14.ElTreeGridRowToggleDirective = (<any>(null as any));
var _decl0_50:i15.ElTreeGridRowToggleComponent = (<any>(null as any));
var _decl0_51:i12.ElSortHeaderIconDirective = (<any>(null as any));
var _decl0_52:i2.AsyncPipe = (<any>(null as any));
var _decl0_53:i2.UpperCasePipe = (<any>(null as any));
var _decl0_54:i2.LowerCasePipe = (<any>(null as any));
var _decl0_55:i2.JsonPipe = (<any>(null as any));
var _decl0_56:i2.SlicePipe = (<any>(null as any));
var _decl0_57:i2.DecimalPipe = (<any>(null as any));
var _decl0_58:i2.PercentPipe = (<any>(null as any));
var _decl0_59:i2.TitleCasePipe = (<any>(null as any));
var _decl0_60:i2.CurrencyPipe = (<any>(null as any));
var _decl0_61:i2.DatePipe = (<any>(null as any));
var _decl0_62:i2.I18nPluralPipe = (<any>(null as any));
var _decl0_63:i2.I18nSelectPipe = (<any>(null as any));
var _decl0_64:i2.KeyValuePipe = (<any>(null as any));
var _decl0_65:i2.CommonModule = (<any>(null as any));
var _decl0_68:i3.ElTableModule = (<any>(null as any));
var _decl0_67:i16.ElIconModule = (<any>(null as any));
var _decl0_69:i0.TemplateRef<any> = (<any>(null as any));
var _decl0_70:i0.ElementRef<any> = (<any>(null as any));
function _View_ElTreeGridComponent_Host_1_0():void {
  var _any:any = (null as any);
  const currVal_0:any = '';
  currVal_0;
  const currVal_1:any = _decl0_30.treeClass;
  currVal_1;
}
function _View_ElTreeGridComponent_1_0():void {
  var _any:any = (null as any);
}
function _View_ElTreeGridRowComponent_Host_2_0():void {
  var _any:any = (null as any);
  const pd_0:any = ((<any>_decl0_32.toggleIfEnabledNode()) !== false);
  const pd_1:any = ((<any>_decl0_32.toggleIfEnabledNodeDeep()) !== false);
}
function _View_ElTreeGridRowComponent_2_0():void {
  var _any:any = (null as any);
}
function _View_ElTreeGridHeaderRowComponent_Host_3_0():void {
  var _any:any = (null as any);
}
function _View_ElTreeGridHeaderRowComponent_3_0():void {
  var _any:any = (null as any);
}
function _View_ElTreeGridFooterRowComponent_Host_4_0():void {
  var _any:any = (null as any);
}
function _View_ElTreeGridFooterRowComponent_4_0():void {
  var _any:any = (null as any);
}
function _View_ElSortHeaderComponent_Host_5_0():void {
  var _any:any = (null as any);
  const currVal_0:any = '';
  currVal_0;
  const currVal_1:any = _decl0_45.disabled;
  currVal_1;
  const pd_2:any = ((<any>_decl0_45.sortIfEnabled()) !== false);
}
function _View_ElSortHeaderComponent_5_1():void {
  if (!_decl0_45.sortIcon) {
    var _any:any = (null as any);
    const currVal_0:any = _decl0_45.direction;
    currVal_0;
  }
}
function _View_ElSortHeaderComponent_5_2():void {
  var _any:any = (null as any);
}
function _View_ElSortHeaderComponent_5_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_45.getDisabledAttributeValue();
  currVal_0;
  const currVal_1:any = !_decl0_45.sortIcon;
  currVal_1;
  const currVal_2:any = _decl0_69;
  currVal_2;
  const currVal_3:any = _decl0_45.getIconContext();
  currVal_3;
  const currVal_4:any = _decl0_45.sortIcon;
  currVal_4;
  const pd_5:any = ((<any>_decl0_45.sortData()) !== false);
}
function _View_ElSortIconComponent_Host_6_0():void {
  var _any:any = (null as any);
}
function _View_ElSortIconComponent_6_2():void {
  if ((_decl0_46.isDirectionSet() && _decl0_46.isAscending())) {
    var _any:any = (null as any);
    const currVal_0:any = 'chevron-down-outline';
    currVal_0;
    const currVal_1:any = 'endlessjs-essentials';
    currVal_1;
    const currVal_2:any = _decl0_29.html;
    currVal_2;
    const currVal_3:any = _decl0_29.primary;
    currVal_3;
    const currVal_4:any = _decl0_29.info;
    currVal_4;
    const currVal_5:any = _decl0_29.success;
    currVal_5;
    const currVal_6:any = _decl0_29.warning;
    currVal_6;
    const currVal_7:any = _decl0_29.danger;
    currVal_7;
  }
}
function _View_ElSortIconComponent_6_3():void {
  if ((_decl0_46.isDirectionSet() && _decl0_46.isDescending())) {
    var _any:any = (null as any);
    const currVal_0:any = 'chevron-up-outline';
    currVal_0;
    const currVal_1:any = 'endlessjs-essentials';
    currVal_1;
    const currVal_2:any = _decl0_29.html;
    currVal_2;
    const currVal_3:any = _decl0_29.primary;
    currVal_3;
    const currVal_4:any = _decl0_29.info;
    currVal_4;
    const currVal_5:any = _decl0_29.success;
    currVal_5;
    const currVal_6:any = _decl0_29.warning;
    currVal_6;
    const currVal_7:any = _decl0_29.danger;
    currVal_7;
  }
}
function _View_ElSortIconComponent_6_1():void {
  if (_decl0_46.isDirectionSet()) {
    var _any:any = (null as any);
    const currVal_0:any = _decl0_46.isAscending();
    currVal_0;
    const currVal_1:any = _decl0_46.isDescending();
    currVal_1;
  }
}
function _View_ElSortIconComponent_6_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_46.isDirectionSet();
  currVal_0;
}
function _View_ElTreeGridRowToggleComponent_Host_7_0():void {
  var _any:any = (null as any);
  const pd_0:any = ((<any>_decl0_50.toggleRow(_any)) !== false);
}
function _View_ElTreeGridRowToggleComponent_7_0():void {
  var _any:any = (null as any);
  const currVal_0:any = (_decl0_50.expanded? 'collapse': 'expand');
  currVal_0;
  const currVal_1:any = (_decl0_50.expanded? 'chevron-down-outline': 'chevron-right-outline');
  currVal_1;
  const currVal_2:any = 'endlessjs-essentials';
  currVal_2;
  const currVal_3:any = _decl0_29.html;
  currVal_3;
  const currVal_4:any = _decl0_29.primary;
  currVal_4;
  const currVal_5:any = _decl0_29.info;
  currVal_5;
  const currVal_6:any = _decl0_29.success;
  currVal_6;
  const currVal_7:any = _decl0_29.warning;
  currVal_7;
  const currVal_8:any = _decl0_29.danger;
  currVal_8;
}
